/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ArrowUpRight, Check, CopyClipboard } from "../assets/ThemeIcon";
import Close from "./icons/Close";
import algo_wallet from "./img/algo-wallet.png";
import pera_wallet from "./img/pera-wallet.png";
const ConnectWalletPopup = ({ popup, setPopup }) => {
	const [connected, setConnected] = useState(false);
	const [copied, setCopied] = useState(false);
	const ref = useRef();
	const handleCopy = async () => {
		const text = ref.current.textContent;
		setCopied(true);
		if ("clipboard" in navigator) {
			return await navigator.clipboard.writeText(text);
		} else {
			return document.execCommand("copy", true, text);
		}
	};

	return (
		<>
			<Modal
				show={popup}
				size="sm"
				aria-labelledby="contained-modal-title-vcenter"
				centered
			>
				<Modal.Body className="__wallet-popup">
					<div
						className="modal-close"
						onClick={() => {
							setConnected(false);
							setPopup(false);
						}}
					>
						<Close />
					</div>
					<h4 className="modal-title">Connect to a wallet</h4>
					<ul className="wallet-list">
						<li
							onClick={() => {
								setConnected(!connected);
								setPopup(false);
							}}
						>
							<span>Pera Wallet</span>
							<img src={pera_wallet} alt="" />
						</li>
						<li
							onClick={() => {
								setConnected(!connected);
								setPopup(false);
							}}
						>
							<span>My Algo Wallet</span>
							<img src={algo_wallet} alt="" />
						</li>
					</ul>
				</Modal.Body>
			</Modal>
			{/* Connected Modal */}
			<Modal
				show={connected}
				size="sm"
				aria-labelledby="contained-modal-title-vcenter"
				centered
			>
				<Modal.Body className="__wallet-popup">
					<div
						className="modal-close"
						onClick={() => {
							setConnected(false);
							setPopup(false);
						}}
					>
						<Close />
					</div>
					<h4 className="modal-title">Account</h4>
					<div className="connected-wallet-content">
						<h6 className="subtitle">Connected with MyAlgoWallet</h6>
						<div className="connected-wallet-content-btn">
							<button
								className="btn-base"
								type="button"
								onClick={() => {
									setConnected(false);
								}}
							>
								Disconnect
							</button>
							<button
								className="btn-base"
								type="button"
								onClick={() => {
									setConnected(false);
									setPopup(!popup);
								}}
							>
								Change Account
							</button>
						</div>
						<ul className="wallet-list mt-3">
							<li>
								<div className="w-20 check-icon">
									<Check />
								</div>
								<span className="me-auto ms-3" ref={ref}>
									EGUS......NH71
								</span>
							</li>
						</ul>
						<div className="mt-3 wallet-connect-info">
							<Link
								to="#"
								onClick={() => {
									handleCopy();
								}}
							>
								<CopyClipboard /> {copied ? "Copied" : "Copy Address"}
							</Link>
							<Link to="/" target="_blank">
								<ArrowUpRight /> View on explorer
							</Link>
						</div>
					</div>
				</Modal.Body>
			</Modal>
			{/* Connected Modal */}
		</>
	);
};

export default ConnectWalletPopup;
